const backendURL = 'https://prod-api.lyearn.com';
const backendAWSEndpoint = 'https://prod-api.lyearn.com';
const appSyncEndpoint =
  'https://dxrl5vi7v5cq7ldqaypkdqbt2i.appsync-api.us-east-1.amazonaws.com/graphql';
const awsESEndpoint =
  'https://search-lyearn-user-es-6luna2pnb2j2st3c426kwtxgtu.us-east-1.es.amazonaws.com';

module.exports = {
  url: backendURL,
  b64URL: Buffer.from(backendURL).toString('base64'),
  awsEndpoint: backendAWSEndpoint,
  appSyncEndpoint,
  awsESEndpoint
};
